/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimageuse2Inputs */

const en_aiimageuse2 = /** @type {(inputs: Aiimageuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this image`)
};

const de_aiimageuse2 = /** @type {(inputs: Aiimageuse2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Bild übernehmen`)
};

/**
* | output |
* | --- |
* | "Use this image" |
*
* @param {Aiimageuse2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimageuse2 = /** @type {((inputs?: Aiimageuse2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimageuse2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimageuse2(inputs)
	return de_aiimageuse2(inputs)
});
export { aiimageuse2 as "aiImageUse" }